import { render, staticRenderFns } from "./IndividualPrinting.vue?vue&type=template&id=95b87ecc&scoped=true&"
import script from "./IndividualPrinting.vue?vue&type=script&lang=js&"
export * from "./IndividualPrinting.vue?vue&type=script&lang=js&"
import style0 from "./IndividualPrinting.vue?vue&type=style&index=0&id=95b87ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b87ecc",
  null
  
)

export default component.exports